import styled from '@emotion/styled';

export const TemplatePanel = styled('div')(({ theme }) => ({
  height: '100%',
  backgroundColor: theme.colors.gray[0],
}));

export const TemplateTextStyles = (theme: any) => ({
  fontFamily: theme.fontFamilyMonospace,
  fontSize: theme.fontSizes.xs,
  whiteSpace: 'pre-wrap' as const,
});
